import router from "../../router";

export const storeRouteFullPath = (uri) => {
    if (typeof window != "undefined" && window) {
        window.sessionStorage.setItem("urlFullPath", JSON.stringify(uri));
    }
};

export const redirectToFromPath = () => {
    if (!window.sessionStorage.getItem("urlFullPath")) {
        router.push({ name: "overview" });
    } else {
        let path = JSON.parse(window.sessionStorage.getItem("urlFullPath"));
        router.push(path);
    }
};
